import { asUserAuthor } from 'domain/shared/author';
import React from 'react';
import { UserProfile } from 'types/user';
import useResourceLegacy from 'util/resource/useResourceLegacy';
import UpdateAPI from 'apis/CompanyAPI/content/UpdateAPI';
import LoadableResource from 'util/resource/Resource';
import useNotify from 'hooks/useNotify';
import UpdateForm from './UpdateForm';
import useLazyResource from 'util/resource/useLazyResource';
import { BoardroomUpdateDTO, CreateBoardroomUpdateDTO } from './types';
import boardroomUpdateAPI from './api';

interface Props {
  setActive: (v: boolean) => void;
  user?: UserProfile;
  onComplete: () => void;
  boardroomUpdate: BoardroomUpdateDTO;
}

export default function EditUpdateDialog(props: Props) {
  const { user } = props;

  const api = boardroomUpdateAPI(props.boardroomUpdate.company.id);
  const notify = useNotify();
  const [editBoardroomPost, isSaving] = useLazyResource(
    (dto: CreateBoardroomUpdateDTO) => api.editUpdate(props.boardroomUpdate.update.id, dto),
    {
      onSuccess: () => {
        props.onComplete();
        props.setActive(false);
        notify('success', 'Post updated!');
      },
      onFailure: () => notify('error', 'Something went wrong when trying to update post'),
    },
  );

  const author = asUserAuthor(user);

  const [attachmentsResource] = useResourceLegacy(
    () =>
      props.boardroomUpdate.update.attachments.length > 0
        ? UpdateAPI.attachments.list(props.boardroomUpdate.update.id)
        : Promise.resolve({ documents: [] }),
    [props.boardroomUpdate.update.id],
  );

  return (
    <LoadableResource resource={attachmentsResource}>
      {attachments => (
        <UpdateForm
          dialogTitle="Edit update"
          titleDraft={props.boardroomUpdate.update.title}
          contentDraft={props.boardroomUpdate.update.content}
          bannerImage={props.boardroomUpdate.update.bannerImage}
          attachments={attachments}
          author={author}
          onSave={editBoardroomPost}
          saveButtonText="Save"
          isSaving={isSaving}
          onClose={() => props.setActive(false)}
          companyId={props.boardroomUpdate.company.id}
          contentId={props.boardroomUpdate.update.id}
        />
      )}
    </LoadableResource>
  );
}
